import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useFeatureFlags } from "../../context/FeatureFlagsContext";

const FooterSection = ({ id, title, openId, onToggle, className = "", children }) => {
  const open = openId === id;
  return (
    <div
      className={`border-b border-gray-700/90 last:border-b-0 md:border-0 md:min-w-[150px] ${className}`}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 py-3.5 text-left md:hidden"
        onClick={() => onToggle(id)}
        aria-expanded={open}
      >
        <span className="text-base font-semibold text-white">{title}</span>
        <ChevronDown
          className={`h-5 w-5 shrink-0 text-gray-400 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
          aria-hidden
        />
      </button>
      <h3 className="mb-2 hidden text-base font-semibold text-white md:block">{title}</h3>
      <div className={`${open ? "block pb-4" : "hidden"} md:block md:pb-0`}>{children}</div>
    </div>
  );
};

const Footer = () => {
  const [openId, setOpenId] = useState(null);
  const { wishlistEnabled } = useFeatureFlags();

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <footer className="bg-gray-900 px-4 py-6 text-white md:py-8">
      <div className="mx-auto max-w-7xl md:flex md:flex-row md:flex-wrap md:justify-between md:gap-8">
        <FooterSection
          id="account"
          title="My Account"
          openId={openId}
          onToggle={toggle}
        >
          <ul className="space-y-2.5 text-sm text-gray-300 md:space-y-1">
            <li>
              <Link to="/user/dashboard" className="hover:text-white hover:underline">
                Track orders
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white hover:underline">
                Shipping
              </Link>
            </li>
            {wishlistEnabled ? (
              <li>
                <Link to="/wishlist" className="hover:text-white hover:underline">
                  Wishlist
                </Link>
              </li>
            ) : null}
            <li>
              <Link to="/user/dashboard" className="hover:text-white hover:underline">
                Order history
              </Link>
            </li>
          </ul>
        </FooterSection>

        <FooterSection id="info" title="Information" openId={openId} onToggle={toggle}>
          <ul className="space-y-2.5 text-sm text-gray-300 md:space-y-1">
            <li>
              <Link to="/privacy-policy" className="hover:text-white hover:underline">
                Privacy policy
              </Link>
            </li>
            <li>
              <Link to="/legal/terms-and-conditions" className="hover:text-white hover:underline">
                Terms & conditions
              </Link>
            </li>
            <li>
              <Link to="/legal/refund-policy" className="hover:text-white hover:underline">
                Refund policy
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white hover:underline">
                Contact us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white hover:underline">
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/vendor/register" className="hover:text-white hover:underline">
                Become seller
              </Link>
            </li>
            <li>
              <Link to="/admin/login" className="hover:text-white hover:underline">
                Admin portal
              </Link>
            </li>
          </ul>
        </FooterSection>

        <FooterSection id="contact" title="Contact" openId={openId} onToggle={toggle}>
          <div className="space-y-1.5 text-sm text-gray-300">
            <p>
              <a href="tel:+918804370669" className="hover:text-white hover:underline">
                +91-8804370669
              </a>
            </p>
            <p>
              <a
                href="mailto:saumyashekhar8051@gmail.com"
                className="hover:text-white hover:underline"
              >
                saumyashekhar8051@gmail.com
              </a>
            </p>
            <p>Patna, Bihar, India</p>
          </div>
        </FooterSection>
      </div>

      <div className="mt-4 border-t border-gray-700 pt-3 text-center text-xs text-gray-400 md:mt-6 md:pt-4">
        &copy; {new Date().getFullYear()} MyMomDad.com. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
